import React from 'react'
import { PageSection } from '../../page-section'
import { ContentProps } from '../../renderer'
import { TypeSectionVerticalTabs } from '../../../lib/types/section-vertical-tabs'
import { VerticalTabs } from './vertical-tabs'
import { getVerticalTabContentItem } from './utils'

export const VerticalTabsSection: React.FC<ContentProps<TypeSectionVerticalTabs>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, heading, itemTab, colorStyle },
  } = structure

  const items = itemTab.map(getVerticalTabContentItem)

  return (
    <PageSection internalName={internalName} sysStructure={sys} className={className} heading={heading}>
      <VerticalTabs items={items} colorStyle={colorStyle} />
    </PageSection>
  )
}
